import React from 'react';
import { motion } from 'framer-motion';
import Hero from './components/Hero';
import Navigation from './components/Navigation';
import Guide from './components/Guide';
import Packages from './components/Packages';
import Accommodation from './components/Accommodation';
import Location from './components/Location';
import FloatingElements from './components/FloatingElements';
import './App.css';

function App() {
  return (
    <div className="app-container">
      <FloatingElements />
      <Navigation />
      <Hero />
      <Guide />
      <Packages />
      <Accommodation />
      <Location />
    </div>
  );
}

export default App;